import { type RootState } from '@reducers';
import { Button, Col, Divider, Form, Input, Row, Space, Spin } from 'antd';
import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { updateUnit } from '../../reducers/property/reducer';
import { SPACING } from '../../theme/tokens';
import BubbleComponent from '../bubble';

interface IForm {
  unit: string;
}

function PropertyUnit(): React.ReactElement {
  const dispatch = useAppDispatch();
  const property = useSelector((s: RootState) => s.Property.property);
  const propertyInProcess = useSelector((s: RootState) => s.Property.inProcess);

  const [form] = Form.useForm<IForm>();

  const onFinish = useCallback(
    ({ unit }: IForm): void => {
      if (property) {
        dispatch(updateUnit(property.code, unit));
      }
    },
    [dispatch, property],
  );

  useEffect(() => {
    if (property) {
      form.setFieldsValue({
        unit: property.unit || '',
      });
    }
  }, [property?.unit, form, property]);

  return (
    <BubbleComponent span={8}>
      <Space size={SPACING.lg} align="start" orientation="horizontal">
        <strong>Unit</strong>
      </Space>
      <Form form={form} onFinish={(values: IForm): void => onFinish(values)}>
        <Row>
          <Col xs={24} md={8}>
            <Space size={SPACING.lg} align="start">
              <Button
                type="primary"
                htmlType="submit"
                disabled={propertyInProcess}
              >
                Submit
              </Button>
              <Spin size="small" spinning={propertyInProcess} />
            </Space>
          </Col>
        </Row>

        <Divider />

        <Row>
          <Col span={24}>
            <Form.Item name="unit" label="Unit">
              <Input placeholder="Unit" disabled={propertyInProcess} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </BubbleComponent>
  );
}

export default PropertyUnit;
